import React, { useEffect, useState } from "react";
import { Tag, Button, message, Empty } from "antd";
import { FilePdfOutlined, DownloadOutlined, EyeOutlined, ReloadOutlined, CalendarOutlined } from "@ant-design/icons";
import axios from "axios";
import "./PdfList.css";

const PdfList = () => {
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPDFList = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token") || "";
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/Pdf/office-to-pdf`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(res.data.data || []);
    } catch { message.error("Failed to fetch PDF list"); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchPDFList(); }, []);

  const formatDate = (d) => {
    try {
      return new Date(d.split(".")[0]).toLocaleDateString("en-IN", {
        day: "numeric", month: "short", year: "numeric",
      });
    } catch { return d; }
  };

  const getFileType = (name = "") => {
    const ext = name.split(".").pop()?.toLowerCase();
    const map = { doc:"Word", docx:"Word", xls:"Excel", xlsx:"Excel", ppt:"PPT", pptx:"PPT", jpg:"Image", jpeg:"Image", png:"Image", webp:"Image" };
    return map[ext] || "File";
  };

  const typeColor = { Word:"#2b5ce6", Excel:"#1a7a43", PPT:"#c84b1e", Image:"#7b3fe4", File:"#888" };

  return (
    <div className="pfl-root">
      <div className="pfl-header">
        <div>
          <div className="pfl-title">Converted PDFs</div>
          <div className="pfl-sub">{data.length} file{data.length !== 1 ? "s" : ""} in your history</div>
        </div>
        <Button icon={<ReloadOutlined />} onClick={fetchPDFList} loading={loading} className="pfl-refresh">Refresh</Button>
      </div>

      {loading ? (
        <div className="pfl-skeleton">
          {[1,2,3,4].map((n) => <div key={n} className="pfl-skeleton-row" />)}
        </div>
      ) : data.length === 0 ? (
        <div className="pfl-empty">
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No converted PDFs yet" />
          <p className="pfl-empty-hint">Use Word to PDF, Excel to PDF or other tools to get started.</p>
        </div>
      ) : (
        <div className="pfl-list">
          {data.map((record, i) => {
            const type = getFileType(record.originalFileName);
            return (
              <div key={record.id || i} className="pfl-row">
                <div className="pfl-row-icon">
                  <FilePdfOutlined style={{ color: "#e5322d", fontSize: 22 }} />
                </div>
                <div className="pfl-row-info">
                  <div className="pfl-row-name">{record.originalFileName || "Converted PDF"}</div>
                  <div className="pfl-row-meta">
                    <Tag className="pfl-type-tag" style={{ background: typeColor[type] + "15", color: typeColor[type], border: "none" }}>{type}</Tag>
                    <span className="pfl-row-date"><CalendarOutlined /> {formatDate(record.uploadDate)}</span>
                    <Tag color={record.status === "Converted" ? "green" : "red"} style={{ borderRadius: 100 }}>{record.status}</Tag>
                  </div>
                </div>
                <div className="pfl-row-actions">
                  <Button
                    type="text"
                    icon={<EyeOutlined />}
                    className="pfl-action-btn"
                    onClick={() => window.open(record.s3Url, "_blank")}
                    title="View"
                  />
                  <Button
                    type="text"
                    icon={<DownloadOutlined />}
                    className="pfl-action-btn"
                    onClick={() => window.open(record.s3Url, "_blank")}
                    title="Download"
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PdfList;
